<app-login-base pageHeader="Set your password">
    <form (ngSubmit)="SetNewPassword()">

        <div class="col-12 text-center" *ngIf="!isRegistrationFlow">
          <p class="text-muted small mb-3" *ngIf="model.email">Resetting password for {{ model.email }}</p>

          <div class="md-form input-white">
                <div class="input-group">
                    <input
                        [(ngModel)]="model.otp"
                        mdbInput
                        mdbValidate
                        name="otp"
                        type="text"
                        id="resetOtp"
                        class="form-control auto-bottom-margin"
                        #otp="ngModel"
                        required
                        maxlength="6"
                        pattern="[0-9]{6}"
                    />
                    <label for="resetOtp">One-time password (6 digits)</label>
                    <mdb-error class="p-1" *ngIf="otp.invalid && (otp.dirty || otp.touched)">
                        Enter the 6-digit code from your email
                    </mdb-error>
                </div>
          </div>
        </div>
      
        <div class="col-12 text-center"> 
          <div class="md-form input-white">
                <div class="input-group">
                    <input 
                        [(ngModel)]="model.password" 
                        mdbInput 
                        mdbValidate 
                        name="resetPassword"
                        type="text" 
                        id="resetPassword" 
                        class="form-control auto-bottom-margin"
                        #password="ngModel" 
                        required
                        [pattern]="'^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$'"
                    />
                    <label for="resetPassword">Password</label>
                    <mdb-error class="p-1" *ngIf="password.invalid && (password.dirty || password.touched)">
                        At lease 8 characters including a number and a uppercase letter
                    </mdb-error>
                    <mdb-success class="p-1" *ngIf="password.valid && (password.dirty || password.touched)">
                    </mdb-success>
                </div>
          </div>       

            <!--Confirm Password -->
            <div class="md-form input-white">
                <div class="input-group">
                    <input
                        [(ngModel)]="model.confirmPassword" 
                        mdbInput
                        mdbValidate
                        name="confirmPassword"
                        type="text"
                        id="confirmPassword"
                        class="form-control auto-bottom-margin"
                        #confirmPassword="ngModel" 
                        required
                        [pattern]="'^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$'"
                    />
                    <label for="confirmPassword">Confirm password</label>
                    <mdb-error class="p-1" *ngIf="confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)">
                        At lease 8 characters including a number and a uppercase letter
                    </mdb-error>
                    <mdb-success class="p-1" *ngIf="confirmPassword.valid && (confirmPassword.dirty || confirmPassword.touched)">
                    </mdb-success>
                </div>
            </div>
        </div>

        <div *ngIf="showError" class="alert alert-danger" role="alert">
            {{ errorMsg }}
        </div>

        <!--Success Display-->
        <div *ngIf="showSuccess" class="alert alert-success" role="alert">
            Password successfully reset. Redirecting to the login page...
        </div>

        <div class="d-flex justify-content-around">
            <div class="col-sm-10 col-md-8">
              <button *ngIf="!busy" mdbBtn color="dooya" block="true" class="my-4" type="submit">Set Password</button>
              <app-loading [busy]="busy"></app-loading>
            </div>
        </div>      
    </form>
</app-login-base>